<template>
  <el-row
    v-if="dataForm.step == '03'"
    style="margin-top :10px"
  >
    <ab-title class="import-quote" title="进口报价" v-if="bizType !== '04'">
      <div class="content-box">
        <el-form
          :model="quoteSeach"
          :rules="rules"
          label-width="100px"
          ref="quoteSeach"
          label-position="top"
        >
          <el-row :gutter="30">
            <el-col :span="12">
              <el-form-item label="发票类型" prop="bizTypeImp" class="quote-form-item">
                <el-select
                  @change="bizTypeImpChange"
                  v-model="quoteSeach.bizTypeImp"
                  :disabled="bizDisabled"
                  placeholder
                  size="small" 
                >
                  <el-option
                    :label="obj.label"
                    :value="obj.value"
                    :key="idx"
                    v-for="(obj, idx) in importOption"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="是否要账期"
                prop="isTaxesAdvanced"
                v-if="dataForm.isTaxesFunction"
                class="quote-form-item"
              >
                <el-select
                  @change="bizTypeImpChange"
                  :disabled="isTaxesDis"  
                  v-model="quoteSeach.isTaxesAdvanced"
                  placeholder
                  size="small"
                >
                  <el-option
                    :label="obj.desc"
                    :value="obj.value"
                    :key="idx"
                    v-for="(obj, idx) in [
                      { value: 1, desc: '是' },
                      { value: 0, desc: '否' }
                    ]"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <div class="discount-box" v-if="imCoupon && imCoupon.number">
                <div class="title">优惠券</div>
                <div
                  class="discount-coupon"
                  @click="imCheckChange(imCoupon.bizType)"
                >
                  <div
                    class="left"
                    :style="{
                      width:
                        imCoupon.discountStr &&
                        imCoupon.discountStr.toString().indexOf('.') != -1
                          ? '130px'
                          : '110px'
                    }"
                  >
                    <p>
                      <span class="discount">{{ imCoupon.discountStr }}</span
                      >折
                    </p>
                  </div>
                  <div class="center">
                    <p class="date">
                      有效期
                      {{ imCoupon.validDateMmDd + "-" + imCoupon.invalidMmDd }}
                    </p>
                    <p class="description">适用于进口业务</p>
                    <p class="description">凭此券,签约服务费享受折扣</p>
                    <p class="number">券 NO.{{ imCoupon.number }}</p>
                  </div>
                  <div class="right">
                    <div class="checkbox">
                      <icon-svg
                        v-if="this.imCheck"
                        style="width: 16px; height: 15px; color: #0B7AFF"
                        name="xuanzhong"
                      ></icon-svg>
                    </div>
                    <p class="text">折扣券</p>
                  </div>
                </div>
              </div>
              <div class="quote-info">
                <p class="tips">
                  <icon-svg name="gantanhao"></icon-svg>
                  {{ importOptionText[quoteSeach.bizTypeImp] }}
                </p>
                <div class="small-bgd">
                  <div class="quote-message">
                    <p class="tit">报价单</p>
                    <div class="q-fl">
                      <p v-if="quoteData.serverBase">
                        服务费率：
                        <span class="isTag-col" v-if="quoteData.quotePrice">{{
                          quoteData.quotePrice.serverBase
                        }}</span
                        ><span class="sp-l">{{ quoteData.serverBase }}</span
                        ><span v-if="bizType === '04'">{{
                          changeUnit(quoteData.serverUnit)
                        }}</span
                        ><span class="sp-l" v-else>%</span>
                      </p>
                      <p v-if="quoteData.minFee">
                        最低收费：<span class="sp-l">{{
                          quoteData.minFee
                        }}</span>
                        <span style="color: #0086d1">元</span>
                      </p>
                    </div>
                  </div>
                  <div class="yixiu-monk"></div>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="quote-description">
                <div class="text">
                  <p class="tit">报价说明:</p>
                  {{quoteSeach.bizTypeImp == '01' ? '1、应收服务费=【委托进口外币金额×结算汇率+海关关税+进口增值税】× 服务费率' : '1、应收服务费=【委托进口外币金额×进口当月海关汇率+海关关税+海关增值税】× 服务费率'}}<br />
                  2、服务费包含香港仓库至受托方国内仓库的汽运费（专车运输除外）及保险费、免租期内仓储费、香港出口报关费、深圳进口报关费、公路舱单费、打单费、查车费，以及深圳市内（坪山新区、大鹏新区除外）1个派送点的派送服务（除此以外的区域按照报价或者实际产生的派送费用收取），未包含的其他费用属于杂费，按实际发生收取。<br />
                  3、付款方式：
                  <span
                    v-if="
                      dataForm.isTaxesFunction &&
                        quoteSeach.isTaxesAdvanced &&
                        quoteData.isTaxesAdvanced
                    "
                  >
                    <template v-if="quoteData.settleType === '02'">
                      月结。每月【1】号至月末所产生的全部费用（进口税款、服务费、杂费等），于次月【5】号前双方对账，于【{{
                        quoteData.settleMode
                      }}】号前委托方付清。
                    </template>
                    <template v-else>
                      单结{{quoteData.settleMode}}天。委托方于货物进口后{{quoteData.settleMode}}日内向受托方支付该批次货物对应的进口税款、服务费、杂费等全部费用。
                    </template>
                  </span>
                  <span v-else
                    >单结预付。委托方于货物进口之日前1日预先向受托方支付该批次货物对应的进口税款、服务费、杂费等全部费用</span
                  ><br />
                  <!-- <span
                    v-if="
                      dataForm.isTaxesFunction &&
                        quoteSeach.isTaxesAdvanced &&
                        quoteData.isTaxesAdvanced &&
                        quoteNotTax.isTaxesAdvanced
                    "
                    >4、若实际没发生垫税，则按不垫收费，费率
                    <span class="is-col" v-if="quoteNotTax.quotePrice">{{
                      quoteNotTax.quotePrice.serverBase
                    }}</span>
                    <span style="color:red;">
                      {{ quoteNotTax.serverBase }} %</span
                    >
                    最低收费{{ quoteNotTax.minFee }}元</span
                  > -->
                </div>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </ab-title>
    <ab-title class="export-quote" title="出口报价" v-if="bizType == '04'">
      <div class="content-box">
        <el-form
          :model="quoteSeach"
          :rules="rules"
          label-width="100px"
          ref="quoteSeach"
          label-position="top"
        >
          <el-row>
            <el-col :span="12">
              <div class="discount-box" v-if="exCoupon && exCoupon.number">
                <div class="title">优惠券</div>
                <div
                  class="discount-coupon"
                  @click="exCheckChange(exCoupon.bizType)"
                >
                  <div
                    class="left"
                    :style="{
                      width:
                        exCoupon.discountStr &&
                        exCoupon.discountStr.toString().indexOf('.') != -1
                          ? '130px'
                          : '110px'
                    }"
                  >
                    <p>
                      <span class="discount">{{ exCoupon.discountStr }}</span
                      >折
                    </p>
                  </div>
                  <div class="center">
                    <p class="date">
                      有效期
                      {{ exCoupon.validDateMmDd + "-" + exCoupon.invalidMmDd }}
                    </p>
                    <p class="description">适用于出口业务</p>
                    <p class="description">凭此券,签约服务费享受折扣</p>
                    <p class="number">券 NO.{{ exCoupon.number }}</p>
                  </div>
                  <div class="right">
                    <div class="checkbox">
                      <icon-svg
                        v-if="this.exCheck"
                        style="width: 16px; height: 15px; color: #0B7AFF"
                        name="xuanzhong"
                      ></icon-svg>
                    </div>
                    <p class="text">折扣券</p>
                  </div>
                </div>
              </div>
              <div class="quote-info">
                <p class="tips">
                  <icon-svg name="gantanhao"></icon-svg>
                  【6%服务费发票】服务费由我司开具6%的增值税专用发票
                </p>
                <div class="small-bgd">
                  <div class="quote-message">
                    <p class="tit">报价单</p>
                    <div class="q-fl">
                      <p v-if="quoteData.serverBase">
                        服务费率：
                        <span class="isTag-col" v-if="quoteData.quotePrice">{{
                          quoteData.quotePrice.serverBase
                        }}</span
                        ><span class="sp-l">{{ quoteData.serverBase }}</span
                        ><span v-if="bizType === '04'">{{
                          changeUnit(quoteData.serverUnit)
                        }}</span
                        ><span class="sp-l" v-else>%</span>
                      </p>
                      <p v-if="quoteData.minFee">
                        最低收费：<span class="sp-l">{{
                          quoteData.minFee
                        }}</span>
                        <span style="color: #0086d1">元</span>
                      </p>
                    </div>
                  </div>
                  <div class="yixiu-monk"></div>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="quote-description">
                <div class="text">
                  <p class="tit">报价说明:</p>
                  1、应收服务费=出口报关美元金额
                  X服务费率（以其他外币报关的，则以出口当月海关汇率折算成人民币后，再折算成美元进行计算）<br />
                  2、出口服务费包含：深圳市内（坪山新区、大鹏新区除外）1个提货点的提货服务（除此以外的区域按照物流费报价表或者实际产生的提货运输费用收取），受托方国内仓库至受托方香港仓库的汽运费（专车运输除外）及保险费、免租期内仓储费、香港进口报关费、深圳出口报关费、公路舱单费、打单费、查车费，以及香港本地1个派送点的运输服务（运输费用不超过港币500元，超出前述价格的部分按照物流报价表或者实际产生的运输费用收取）。<br />
                  3、付款方式：
                  <template v-if="quoteData.settleType === '02'">
                    月结。每月【1】号至月末产生的费用，于次月【5】号前双方对账，于【{{
                      quoteData.settleMode
                    }}】号前委托方结清。
                  </template>
                  <template v-else>
                    预付：委托方于货物出口之日前1日预先向受托方支付该批次货物出口服务费。
                  </template>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </ab-title>
    <div class="footer">
      <el-button
        type="primary"
        @click="getLatest('next')"
        :loading="isloading"
        v-if="isStepBtn"
        >下一步</el-button
      >
      <el-button @click="backToStep" :loading="isloading"
        >返回</el-button
      >
    </div>
  </el-row>
</template>

<script>
import "../../../assets/css/index.scss";
export default {
  data() {
    return {
      //  选择进口优惠券
      bizTypes: [],
      imCheck: false,
      imExpan: true,
      exExpan: true,
      exCheck: false,
      isloading: false,
      listLoadong: false,
      coupLoading: false,
      isStepBtn: false,
      coupCodeImpDisd: false,
      coupCodeExpDisd: false,
      quoteData: {},
      quoteNotTax: {}, //不垫税
      quoteSeach: {},
      bizType: "",
      importOption: [],
      importOptionText: {
        "01":
          "【13%增值税专用发票】是指海关税金缴款书由我司抵扣，由我司将货值和代理费一起开13%的增值税专用发票给贵司作为进项抵扣。",
        "02":
          "【海关税票+6%服务费发票】是指海关税金缴款书直接作为进项由贵司抵扣，服务费由我司开具6%的增值税专用发票。"
      },
      rules: {
        bizTypeImp: [
          { required: true, message: "请选择发票类型", trigger: "change" }
        ],
        isTaxesAdvanced: [
          { required: true, message: "请选择是否要账期", trigger: "change" }
        ]
      }
    };
  },
  props: {
    dataForm: {
      type: Object,
      defualt: {}
    },
    canSignBizTypeList: {
      type: Array,
      defualt: []
    }
  },
  computed: {
        bizDisabled() {
            if(this.bizTypes && this.bizTypes.length) {
                let arr = this.bizTypes.filter(ele=>ele.bizBigType != '02')
                return (arr.filter(ele=>ele.quoteTypeDesc == '定制').length == 1 && this.quoteData.quoteTypeDesc == '定制') || this.importOption.length == 1
            }
        },
        isTaxesDis() {
            if(this.bizTypes && this.bizTypes.length) {
              if(this.quoteSeach.bizTypeImp) {
                  let obj = this.bizTypes.filter(ele=>ele.bizType == this.quoteSeach.bizTypeImp)[0]
                  return !obj.taxQuotePriceVo
              }
            }
            return false
        },
    imCoupon() {
      let a = {};
      this.disCouList.forEach(ele => {
        if (ele.bizType != "04") {
          a = ele;
        }
      });
      return a;
    },
    exCoupon() {
      let a = {};
      this.disCouList.forEach(ele => {
        if (ele.bizType == "04") {
          a = ele;
        }
      });
      return a;
    },
    disCouList: {
      get() {
        return this.$store.state.disCouList;
      },
      set(val) {
        this.$store.commit("updaetDisCouList", val);
      }
    }
  },
  watch: {
    "dataForm.step": {
      handler(val) {
        if (val == "03") {
          // this.$utils.clearPoll('agreemant-renewal') 
          // window.SITE_CONFIG['poll']['agreemant-renewal'] = window.setInterval(() => {
          //     setTimeout(() => {
          //         this.getLatest()
          //     },0)
          // },10000)
          if (
            this.dataForm.bizTypes.length == 5 ||
            this.dataForm.bizTypes == "01"
          ) {
            this.bizType = this.canSignBizTypeList.includes("02")
              ? "02"
              : "01";
          } else {
            this.bizType = "04";
          }
          if (this.dataForm.isTaxesFunction) {
            this.quoteSeach.isTaxesAdvanced = this.dataForm.isTaxesAdvanced
          }
          this.getCheckPrice();
        }else{
          // this.$utils.clearPoll('agreemant-renewal') 
        }
      },
      immediate: true
    },
  },
  activated() {},

  methods: {
    bizTypeImpChange() {
      this.clientGetOne(
        this.quoteSeach.bizTypeImp,
        this.quoteSeach.coupCodeImp
      );
    },
    getLatest(next) {
        this.getCheckPrice(true, next)
    },
    imCheckChange(type, flag) {
      if (type == "04") {
        this.$message.error("该优惠券业务类型不匹配，请重新选择！");
        return;
      }
      // if(flag) {
      //     this.imExpan = !this.imExpan
      //     this.imCheck = this.imExpan
      // }else{
      //     this.imCheck = !this.imCheck
      // }
      if (this.imCheck) {
        this.$confirm(
          "确定不使用折扣劵吗？ 使用折扣劵将享受更低服务费费率哦！",
          "温馨提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          this.clickImQuote();
        });
      } else {
        this.clickImQuote();
      }
    },
    clickImQuote() {
      this.imCheck = !this.imCheck;
      this.quoteSeach.coupCodeImp = this.imCheck ? this.imCoupon.number : "";
      this.clientGetOne(
        this.quoteSeach.bizTypeImp,
        this.quoteSeach.coupCodeImp
      );
    },
    exCheckChange(type, flag) {
      if (type != "04") {
        this.$message.error("该优惠券业务类型不匹配，请重新选择！");
        return;
      }
      // if(flag) {
      //     this.exExpan = !this.exExpan
      //     this.exCheck = this.exExpan
      // }else{
      //     this.exCheck = !this.exCheck
      // }
      this.exCheck = !this.exCheck;
      this.quoteSeach.coupCodeExp = this.exCheck ? this.exCoupon.number : "";
      this.clientGetOne(type, this.quoteSeach.coupCodeExp);
    },
    getCheckPrice(flag, next) {
      this.listLoadong = true;
      this.$post('/crm/clientRegisterStep/checkPrice', this.dataForm).then(({data}) => {                  
        if(flag && this.bizTypes && this.bizTypes.length) {
                        let oldObj = JSON.stringify(this.bizTypes)
                        let newObj = JSON.stringify(data.result)
                        if(oldObj != newObj) {
                            // this.$utils.clearPoll('home')
                            this.$confirm('报价有更新，请点击确定获取最新的报价！', '温馨提示', {
                                confirmButtonText: '确定',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false,
                                showCancelButton: false,
                                type: 'warning'
                            }).then(() => {
                                this.getCheckPrice()
                                // this.$utils.clearPoll('home')
                                // window.SITE_CONFIG['poll']['home'] = window.setInterval(() => {
                                //     setTimeout(() => {
                                //             this.getLatest()
                                //     },0)
                                // },6000)
                            })
                            return
                        }
                        if(next) {
                            this.nextStep()
                        }
                        return
                    }
        this.importOption = []
        this.bizTypes = data.result
      //查报价，根据报价筛选 进口的业务类型，以及先展示那个报价
        let arr1 = []
        this.bizTypes.forEach(e=>{
          if(this.canSignBizTypeList.includes(e.bizType)) {
            arr1.push(e)
          }
        })  
        if (this.dataForm.bizTypes.length > 0) {
            if (this.canSignBizTypeList.includes("01")) {
              this.importOption.push({
                label: "13% 增值税专用发票",
                value: "01"
              });
            } 
            if (this.canSignBizTypeList.includes("02")) {
              this.importOption.push({
                label: "海关税票+6%服务费发票",
                value: "02"
              });
            }
          this.bizType = arr1[0].bizType;
          if(this.bizTypes.filter(e=>{e.bizType == this.quoteSeach.bizTypeImp}) && this.bizTypes.filter(e=>{e.bizType == this.quoteSeach.bizTypeImp}).length) {

          }else if((this.bizType == '01' || this.bizType == '02') && this.bizDisabled){
            this.quoteSeach.bizTypeImp = this.bizType
          }
          if (this.dataForm.coupNumberStrDesc) {
            if (this.dataForm.coupNumberStrDesc["01"]) {
            this.quoteSeach.coupCodeImp = this.dataForm.coupNumberStrDesc["01"]
              this.imCheck = true;
              // this.coupCodeImpDisd = true
            }
            if (this.dataForm.coupNumberStrDesc["02"]) {
              this.quoteSeach.coupCodeExp = this.dataForm.coupNumberStrDesc["02"]
              this.exCheck = true;
              // this.coupCodeExpDisd = true
            }
            if (this.dataForm.coupNumberStrDesc.bizTypeExp) {
              //this.bizType = this.dataForm.coupNumberStrDesc.bizTypeExp
            }                            
            if (this.dataForm.coupNumberStrDesc.bizTypeImp && this.bizTypes.filter(e=>{e.bizType == this.dataForm.coupNumberStrDesc.bizTypeImp}) && this.bizTypes.filter(e=>{e.bizType == this.dataForm.coupNumberStrDesc.bizTypeImp}).length) {
              //this.bizType = this.dataForm.coupNumberStrDesc.bizTypeImp
              this.quoteSeach.bizTypeImp = this.dataForm.coupNumberStrDesc.bizTypeImp
            }
          }                        
          let arr = this.bizTypes.filter(ele=>ele.bizBigType != '02')
          if(arr.filter(ele=>ele.quoteTypeDesc == '定制' && this.canSignBizTypeList.includes(ele.bizType)).length == 1) {
            this.quoteSeach.bizTypeImp = arr.filter(ele=>ele.quoteTypeDesc == '定制')[0].bizType
          }
          if (sessionStorage.getItem("firstIn")) {
            this.imCheck = true;
            this.quoteSeach.coupCodeImp = this.imCoupon.number
            this.exCheck = true;
            this.quoteSeach.coupCodeExp = this.exCoupon.number
          }
          if(this.quoteSeach.bizTypeImp || this.bizType == '04') {
            this.clientGetOne(
              this.bizType == '04' ? '04' : this.quoteSeach.bizTypeImp,
              this.bizType == "04"
                ? this.quoteSeach.coupCodeExp
                : this.quoteSeach.coupCodeImp
            );
          }
        }
      })
    },
    backToStep() {
      this.isloading = true;
      let that = this
      this.$parent
        .backToStep("01")
        .then(() => {})
        .finally(() => {
          this.isloading = false;
        });
    },
    clientGetOne(bizType, coupCodeNumber) {
      this.listLoadong = true;
      this.$post("/crm/quotePrice/clientGetOne", {
        bizType: bizType,
        customerName: this.dataForm.enterpriseName,
        coupCodeNumber: coupCodeNumber
      })
        .then(({ data }) => {
          if (data && data.code == "C0000") {
            this.listLoadong = false;
            this.coupLoading = false;
            this.isStepBtn = true;
            if (
              data.result.taxQuotePriceVo &&
              this.quoteSeach.isTaxesAdvanced
            ) {
              this.quoteNotTax = data.result;
              this.quoteData = data.result.taxQuotePriceVo;
            } else {
              this.quoteData = data.result;
            }
            if (!this.bizTypes.filter(ele=>ele.bizType == this.quoteSeach.bizTypeImp)[0].taxQuotePriceVo) {
              if (bizType == '01' || bizType == '02') {
                  this.quoteSeach.isTaxesAdvanced = this.quoteData.isTaxesAdvanced
                }
              }
          } else {
            this.isStepBtn = false;
            this.$message.error(data.message);
          }
        })
        .finally(() => {
          this.listLoadong = false;
          this.coupLoading = false;
        });
    },
    changeUnit(data) {
      if (!data) {
        return "";
      }
      if (data == "CNY") {
        return "人民币";
      } else if (data == "%") {
        return data;
      } else {
        return "人民币/" + data;
      }
    },
    nextStep() {
      this.$refs["quoteSeach"].validate(valid => {
        if (valid) {
          let obj = {};
          if (this.dataForm.bizTypes.length == 5) {
            obj.bizTypeImp = this.quoteSeach.bizTypeImp;
            obj.bizTypeExp = "04";
            if (this.bizType != "04") {
              //当前 是进口报价
              this.bizType = "04"; //切换到出口报价
              if (sessionStorage.getItem("firstIn")) {
                this.quoteSeach.coupCodeExp = this.exCoupon.number
                this.exCheck = true;
              }
              this.clientGetOne(this.bizType);
              return false;
            }
          }
          if (this.dataForm.bizTypes == "02") {
            obj.bizTypeExp = "04";
          } else if (this.dataForm.bizTypes == "01") {
            obj.bizTypeImp = this.quoteSeach.bizTypeImp;
          }
          obj.step = "05";

          obj.isTaxesAdvanced = this.quoteSeach.isTaxesAdvanced;

          if (this.quoteSeach.coupCodeImp) {
            obj.coupCodeImp = this.quoteSeach.coupCodeImp;
          }
          if (this.quoteSeach.coupCodeExp) {
            obj.coupCodeExp = this.quoteSeach.coupCodeExp; 
          }
          this.isloading = true;
          let params = Object.assign({}, this.dataForm, obj);
          let that = this
          this.$parent
            .gotoStep(params)
            .then(() => {})
            .finally(() => {
              that.isloading = false;
            });
        }
      });
    }
  }
};
</script>
<style lang="scss">
.import-quote,
.export-quote {
  .content-box {
    padding: 20px;
    .el-form-item {
      height: auto;
      margin-bottom: 30px;
      .el-form-item__label {
        font-size: 14px;
        margin-bottom: 10px;
      }
      .el-input__inner {
        height: 60px;
        width: 394px;
        font-weight: bold;
        border: 0;
        text-indent: 15px;
        background-color: #f3f8fc;
      }
    }

        .quote-info{
            float: left;
            position: relative;
            // padding: 3.125vw;
            margin-top: 26px;
            width: 640px;
            height: 311px;
            background: url("../../../assets/img/sign/contract/bigyixiu-bgd.png");
            background-repeat: no-repeat;
            background-size: cover;
            .tips{
                position: absolute;
                width: calc(100% - 50px);
                left: 29px;
                top: 12px;
                line-height: 20px;
                color: #646668;
                font-size: 14px;
                .icon-svg{
                    float: left;
                    width: 16px;
                    height: 16px;
                }
            }
            .small-bgd{
                width: 580px;
                height: 200px;
                background: url("../../../assets/img/sign/contract/small-yixiu-bgd.png");
                background-repeat: no-repeat;
                background-size: cover;
                position: absolute;
                top: 60px;
                left: 29px;
                .quote-message{
                    margin-left: 51px;
                    margin-top: 42px;
                    float: left;
                    .tit{
                        font-size: 16px;
                        font-family: PingFangSC-Regular, 'Noto Sans SC', Microsoft YaHei;
                        font-weight: bold;
                        color: #000000;
                        margin-bottom: 15px;
                    }
                    .q-fl{
                        // font-size: 14px;
                        .isTag-col {
                            text-decoration: line-through;
                            color: #bdbdbd;
                            // font-size:20px;
                        }
                        p{
                            margin-bottom: 10px;
                            span{
                                color:#000000;
                            }
                        }
                        .sp-l{
                            // font-size: 20px;
                            color: #0086d1;
                            font-weight: bold;
                        }
                    }
                }
            }
            .yixiu-monk{
                width: 219px;
                height: 215px;
                background: url("../../../assets/img/sign/contract/yixiu-monk.png");
                background-repeat: no-repeat;
                background-size: cover;
                position: absolute;
                right: 80px;
                bottom: -5px;
            }
        }
    .discount-box {
      .title {
        // font-size: 16px;
        font-weight: 400;
        margin-bottom: 11px;
      }
      .discount-coupon {
        cursor: pointer;
        width: 395px;
        height: 130px;
        background: url("../../../assets/img/sign/contract/coupon-bgd.png");
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
        .left {
          float: left;
          position: relative;
          height: 100%;
          color: #2584ef;
          font-weight: bold;
          text-align: center;
          p {
            padding-top: 30px;
            position: absolute;
            width: 100%;
            left: 10px;
            height: 100%;
            // font-size: 20px;
          }
          .discount {
            font-size: 48px;
          }
        }
        .center {
          float: left;
          width: 200px;
          height: 100%;
          // font-size: 14px;
          color: #646668;
          .date {
            color: #0b7aff;
            // font-size: 16px;
            margin: 27px 0 6px 0;
            font-weight: bold;
          }
          .number {
            margin-top: 18px;
          }
        }
        .right {
          width: 65px;
          height: 100%;
          float: right;
          .text {
            // font-size: 18px;
            font-weight: bold;
            color: #ffffff;
            -webkit-writing-mode: vertical-rl;
            writing-mode: vertical-rl;
            letter-spacing: 6px;
            font-family:  PingFangSC-Regular, 'Noto Sans SC', Microsoft YaHei;
            position: absolute;
            top: 33px;
            right: 23px;
          }
          .checkbox {
            width: 16px;
            height: 16px;
            border-radius: 4px;
            background-color: #fff;
            position: absolute;
            top: 8px;
            right: 25px;
          }
        }
      }
    }
    .quote-description {
      margin-top: 30px;
      width: calc(100% - 40px);
      background-color: #f3f8fc;
      padding: 0.7813vw 10px 0.7292vw 0.7813vw;
      // font-size: 14px;
      color: #646668;
      line-height: 20px;
      .text {
        width: 100%;
      }
      .tit {
        // font-size: 14px;
        color: #000;
        margin-bottom: 5px;
      }
    }
  }
  .content-box .el-form-item .el-input__inner{
    height: 60px !important;
    font-size: 14px;
    font-weight: unset;
    font-family: "PingFangSC-Regular", "Noto Sans SC";
  }
}
</style>
